import {AppConfig, BaseAppProps, BaseAppState, clearProvisioningId} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS, lightMediumGray} from "../shared/colors";
import {Main} from "./Main";
import {PathComponent} from "../index";
import {FIREBASE_CONFIG} from "../consts";
import {SZ_MD} from "../shared/dimens";
import {ProvisionedApp} from "../shared/ProvisionedApp";
import {AppPrefListener, ProvisionedAppConfig} from "../shared/types";
import {AppPrefs} from "./app_prefs";
import {BaseAppPrefs} from "../shared/BaseAppPrefs";

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

const BOLD_FONT_WEIGHT = "600";
export const COLOR_PRIMARY = "#006";
export const COLOR_SECONDARY = "#06f";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  components: {
    ...DEFAULT_THEME_OPTIONS.components,
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: BOLD_FONT_WEIGHT,
          fontSize: "75%",
        },
      }
    },
    // MuiPaper: {
    //   styleOverrides: {
    //     elevation: {
    //       boxShadow: CARD_SHADOW_LARGE,
    //     },
    //   },
    // },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    h1: {
      fontWeight: BOLD_FONT_WEIGHT,
      lineHeight: 1,
    },
    h2: {
      fontWeight: BOLD_FONT_WEIGHT,
      lineHeight: 1,
    },
    h3: {
      fontWeight: BOLD_FONT_WEIGHT,
      lineHeight: 1,
    },
    h4: {
      fontWeight: BOLD_FONT_WEIGHT,
      lineHeight: 1,
    },
    h5: {
      fontWeight: BOLD_FONT_WEIGHT,
      lineHeight: 1,
    },
    h6: {
      fontWeight: BOLD_FONT_WEIGHT,
      lineHeight: 1,
    },
    fontFamily: "Inter, sans-serif",
    fontSize: 14,
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#fff",
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: "#000",
    },
    background: {
      default: lightMediumGray,
      paper: "white",
    }
  }
};

export const THEME = createTheme(THEME_OPTIONS);

export class AppRefs {

  constructor(
    readonly audio: HTMLAudioElement) {
  }
}

export class App extends ProvisionedApp<AppProps, AppState>
  implements AppPrefListener {

  private static appRefs: AppRefs;

  static getAppRefs(): AppRefs {
    if (!App.appRefs) {
      App.appRefs = App.createAppRefs();
    }
    return App.appRefs;
  }

  private static createAppRefs() {
    return new AppRefs(
      document.getElementById("player") as HTMLAudioElement
    );
  }

  getProvisionedAppId(): string {
    return "zyrcona";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return undefined;
  }

  getPreferredColorScheme(): "light" | "dark" | null | undefined {
    return "dark";
  }

  onCreateAppConfig(): AppConfig {
    return {
      name: "Workbench",
      icon: "/icon.png",
      logo: "/logo192.png",
      stamp: "/stamp.png",
      stampHeight: SZ_MD,
      defaultUserImage: "/images/default_user.png",
      theme: {
        ...THEME,
        typography: {
          ...THEME.typography,
        },
      },
      styleConfig: {
        defaultContainerSize: "xxxlg",
      },
      loginConfig: {
        provisioning: {
          signupDisabled: true,
          enabled: true,
          onChangeProvisioning: () => clearProvisioningId(),
        },
      },
      firebaseConfig: {options: FIREBASE_CONFIG},
    };
  }

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  getAppPrefs<T extends BaseAppPrefs>(): T {
    //@ts-ignore
    return AppPrefs.getInstance() as T;
  }

  protected renderMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
